import classNames from 'classnames'
import moment from 'moment'
import { type ReactNode } from 'react'

import { type ICommonField } from '@/app/types/common'
import { Datepicker } from '@/shared'

import style from './DateField.module.scss'
import { Notificator } from './Notificator/Notificator'

interface IProps {
    entity: ICommonField
    onChange: (e: moment.Moment) => void
    onSetIsTouched?: () => void
    className?: string
    disabled?: boolean
    isNotificator?: boolean
    titleMarker?: ReactNode
}

export const DateField = (props: IProps) => {
    const { entity, isNotificator, onChange, onSetIsTouched, className, disabled, titleMarker } = props

    if (isNotificator && entity.value) {
        return <Notificator value={`${entity.name}: ${moment(entity.value).format('DD.MM.YYYY')}`} />
        // return <div className={style.container}>{fieldValue}</div>
    }

    return (
        <div className={classNames(style.container, className && className)}>
            <div className={style.blockTitle}>
                <span>{entity.name}</span>
                {titleMarker}
            </div>
            <Datepicker
                value={entity.value ? moment(entity.value) : null}
                onChange={onChange}
                onSetIsTouched={onSetIsTouched}
                disabled={disabled}
                error={entity.error}
                isTouched={entity.isTouched}
            />
        </div>
    )
}
